
import { Expense, IncomeExpense } from "../../classes"

const ExpenseModule = {
  namespaced: true,
  state: {
    expense: null
  },
  mutations: {
    setExpense(state, expense) {
      state.expense = expense
    },
    clearExpense: (state) => {
      state.expense = null
    },
  },
  actions: {
    getExpense: async ({ commit }, id) => {
      try{
        commit("clearExpense")
        const data = await Expense.getExpense(id)
        commit("setExpense", data)
        commit("incomeExpense/updateIncomeExpense", IncomeExpense.generateByExpense(data), { root: true })
        return data
      }catch(error){
        throw error
      }
    },
    createExpense: async ({ dispatch }, formData) => {
      try {
        const data = await Expense.createExpense(formData);
        await dispatch("getExpense", data.objectId)
        return data;
      } catch (error) {
        throw error;
      }
    },
    updateExpense: async ({ dispatch }, formData) => {
      try {
        const data = await Expense.updateExpense(formData);
        await dispatch("getExpense", data.objectId)
        return data;
      } catch (error) {
        throw error;
      }
    },
    removeExpense: async ({ commit }, id) => {
      try {
        const data = await Expense.removeExpense(id);
        commit("incomeExpense/removeIncomeExpense", id, { root: true })
        return data;
      } catch (error) {
        throw error;
      }
    },
  },
  getters: {

  },
};
export default ExpenseModule;
